export default __webpack_public_path__ + "static/media/run-buddy2.275ae402.jpeg";